export default __webpack_public_path__ + "static/media/error-404.8a3e9179.jpg";